var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "form-group filterfield",
      attrs: {
        id: _vm.htmlId,
        "data-filterfield-type": _vm.definition.componentName,
      },
    },
    [
      _vm.showLabel
        ? _c(
            "label",
            { staticClass: "col-xs-12", attrs: { for: _vm.inputId } },
            [
              _vm._v(_vm._s(_vm.displayName) + "\n\t\t"),
              _vm.minDateDisplay && _vm.maxDateDisplay
                ? _c(
                    "small",
                    {
                      staticClass: "text-muted",
                      staticStyle: { "font-weight": "normal" },
                    },
                    [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.minDateDisplay) +
                          " to " +
                          _vm._s(_vm.maxDateDisplay) +
                          ")"
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.definition.metadata.field
        ? _c("Debug", [
            _c("label", { staticClass: "col-xs-12" }, [
              _vm._v(
                "(id: " +
                  _vm._s(_vm.id) +
                  " [" +
                  _vm._s(_vm.definition.metadata.field) +
                  "])"
              ),
            ]),
          ])
        : _vm.definition.metadata.from_field
        ? _c("Debug", [
            _c("label", { staticClass: "col-xs-12" }, [
              _vm._v(
                "(id: " +
                  _vm._s(_vm.id) +
                  " [" +
                  _vm._s(_vm.definition.metadata.from_field) +
                  " - " +
                  _vm._s(_vm.definition.metadata.to_field) +
                  "])"
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticStyle: { margin: "0 15px" } }, [
        _c("div", { staticClass: "dates" }, [
          _vm.definition.metadata.range
            ? _c("label", [_vm._v("From: ")])
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.yearFrom,
                expression: "yearFrom",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "number",
              title: "year",
              placeholder: "year",
              min: _vm.minYear,
              max: _vm.maxYear,
            },
            domProps: { value: _vm.yearFrom },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.yearFrom = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.monthFrom,
                expression: "monthFrom",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "number",
              title: "month",
              placeholder: "month",
              min: "1",
              max: "12",
            },
            domProps: { value: _vm.monthFrom },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.monthFrom = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.dayFrom,
                expression: "dayFrom",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "number",
              title: "day",
              placeholder: "day",
              min: "1",
              max: _vm.startMonthLength,
            },
            domProps: { value: _vm.dayFrom },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.dayFrom = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _vm.definition.metadata.range
          ? _c("div", { staticClass: "dates" }, [
              _c("label", [_vm._v("To: ")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.yearTo,
                    expression: "yearTo",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  title: "year",
                  placeholder: "year",
                  min: _vm.minYear,
                  max: _vm.maxYear,
                },
                domProps: { value: _vm.yearTo },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.yearTo = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.monthTo,
                    expression: "monthTo",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  title: "month",
                  placeholder: "month",
                  min: "1",
                  max: "12",
                },
                domProps: { value: _vm.monthTo },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.monthTo = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.dayTo,
                    expression: "dayTo",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  title: "day",
                  placeholder: "day",
                  min: "1",
                  max: _vm.endMonthLength,
                },
                domProps: { value: _vm.dayTo },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.dayTo = $event.target.value
                  },
                },
              }),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.definition.metadata.mode && _vm.definition.metadata.range
        ? _c(
            "div",
            {
              staticClass: "btn-group col-xs-12",
              staticStyle: { "margin-left": "calc(15px + 3em)" },
            },
            [
              _vm._l(_vm.modes, function (mode) {
                return _c(
                  "button",
                  {
                    key: mode.value,
                    class: [
                      "btn btn-default",
                      { active: _vm.value.mode === mode.value },
                    ],
                    attrs: {
                      type: "button",
                      value: mode.value,
                      title: mode.title || "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.e_input({ ..._vm.value, mode: mode.value })
                      },
                    },
                  },
                  [_vm._v(_vm._s(mode.label))]
                )
              }),
              _vm._v(" "),
              !_vm.value.isDefaultValue
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.e_input(null)
                        },
                      },
                    },
                    [_vm._v("reset")]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.description
        ? _c("div", { staticClass: "col-xs-12" }, [
            _c("small", { staticClass: "text-muted description" }, [
              _c("em", [_vm._v(_vm._s(_vm.description))]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }